import { UserId } from '@shared/types/users.ts';

export const apiRoutes = {
  getAdvertisersAssignedToUser: (userId: UserId) => `/users/${userId}/advertisers`,
  getUserProfile: () => `/user-profile`,
  postUserProfile: () => `/user-profile`,
  getUserProfileById: (userId: UserId) => `/user-profile/${userId}`,
  putUserProfile: (userProfileId: string) => `/user-profile/${userProfileId}`,
};
